import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, NavLink } from "react-router-dom";
import { Collapse } from "reactstrap";
import classnames from "classnames";
import axios from "axios";

import IntlMessages from "../../helpers/IntlMessages";
import menuItems from "../../constants/menu";
import { toggleMenuCollapse, setMenuLayoutType } from "../../redux/actions";
import { END_POINT } from "../../constants/defaultValues";
import createSocket from "../../helpers/createSocket";

class SidebarModern extends Component {
  constructor(props) {
    super(props);
    const initialPath = props.location ? props.location.pathname : "";
    this.state = {
      openAccordions: this.getInitialOpenAccordions(initialPath),
      un_seen_mess: null,
      eInvoiceEnabled: false,
      hoveredTooltipItem: null,
      tooltipTop: 0,
    };
    this.socket = createSocket();
  }

  componentDidMount() {
    this.fetchEInvoiceCapability();

    const userId = localStorage.getItem("b") || localStorage.getItem("user_id");
    if (userId) {
      this.socket.emit("join room", { room_id: userId });
      this.socket.emit("refresh-alert-data", { user_id: userId });
    }

    this.socket.on("refresh-alert-data", (res) => {
      if (res && res.un_seen_mess !== undefined) {
        this.setState({ un_seen_mess: res.un_seen_mess });
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.menuCollapsed !== this.props.menuCollapsed && !this.props.menuCollapsed) {
      if (this.state.hoveredTooltipItem) {
        this.setState({ hoveredTooltipItem: null });
      }
    }
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const currentPath = this.props.location.pathname;
      const initialOpen = this.getInitialOpenAccordions(currentPath);
      this.setState((prevState) => ({
        openAccordions: Array.from(
          new Set([...prevState.openAccordions, ...initialOpen])
        ),
      }));
    }
  }

  componentWillUnmount() {
    if (this.socket) {
      this.socket.close();
    }
  }

  fetchEInvoiceCapability = () => {
    const tenantUserId = localStorage.getItem("user_id") || "";
    const tokenStr = localStorage.getItem("access_token");

    if (!tenantUserId || !tokenStr) return;

    axios
      .get(`${END_POINT}/api/einvoice/config?user_id=${tenantUserId}`, {
        headers: { Authorization: `Bearer ${tokenStr}` },
        silent: true,
      })
      .then((res) => {
        this.setState({ eInvoiceEnabled: !!res.data?.data?.is_active });
      })
      .catch(() => {
        this.setState({ eInvoiceEnabled: false });
      });
  };

  isPathActive = (toPath, item) => {
    const { location } = this.props;
    const currentPath = location ? location.pathname : "";
    if (!toPath) return false;

    if (toPath === currentPath) return true;

    // Special aliases
    if (toPath === "/app/pages/ecommerce") {
      return (
        currentPath === "/app/pages/ecommerce" ||
        currentPath === "/app/pages/shopee" ||
        currentPath === "/app/pages/tiktok-shop" ||
        currentPath === "/app/pages/lazada" ||
        currentPath === "/app/pages/tiki" ||
        currentPath.startsWith("/app/pages/ecommerce-products")
      );
    }

    if (toPath === "/app/pages/product") {
      return (
        currentPath === "/app/pages/product" ||
        currentPath.startsWith("/app/pages/product/") ||
        currentPath === "/app/pages/category" ||
        currentPath === "/app/pages/make-product"
      );
    }

    if (toPath === "/app/dashboards/default") {
      return (
        currentPath === "/app/dashboards/default" ||
        currentPath === "/app/dashboards" ||
        currentPath.startsWith("/app/dashboards/")
      );
    }

    if (toPath === "/app/pages/order") {
      return (
        currentPath === "/app/pages/order" ||
        currentPath === "/app/pages/invoice" ||
        currentPath.startsWith("/app/pages/order/")
      );
    }

    if (toPath === "/app/pages/cash-flow") {
      return (
        currentPath === "/app/pages/cash-flow" ||
        currentPath === "/app/pages/income" ||
        currentPath === "/app/pages/outcome"
      );
    }

    if (toPath === "/app/pages/stock") {
      return (
        currentPath === "/app/pages/stock" ||
        currentPath.startsWith("/app/pages/stock/") ||
        currentPath === "/app/pages/warehouse-export" ||
        currentPath === "/app/pages/warehouse-transfer"
      );
    }

    if (toPath !== "/app" && currentPath.startsWith(toPath + "/")) {
      return true;
    }

    // Check children recursively
    if (item && item.subs && item.subs.length > 0) {
      return item.subs.some((sub) => this.isPathActive(sub.to, sub));
    }

    return false;
  };

  getInitialOpenAccordions = (pathname) => {
    const openKeys = [];
    if (!pathname) return openKeys;

    menuItems.forEach((item) => {
      if (item.subs && item.subs.length > 0) {
        if (this.isPathActive(item.to, item)) {
          openKeys.push(item.id);
        }
        item.subs.forEach((sub, subIndex) => {
          if (sub.subs && sub.subs.length > 0) {
            if (this.isPathActive(sub.to, sub)) {
              openKeys.push(`${item.id}_${subIndex}`);
            }
          }
        });
      }
    });

    return openKeys;
  };

  toggleAccordion = (key) => {
    const { openAccordions } = this.state;
    if (openAccordions.includes(key)) {
      this.setState({
        openAccordions: openAccordions.filter((k) => k !== key),
      });
    } else {
      this.setState({
        openAccordions: [...openAccordions, key],
      });
    }
  };

  filteredList = (items) => {
    const { currentUser } = this.props;
    const businessType = localStorage.getItem("businessType");
    const isAdmin = localStorage.getItem("admin") === "true";
    const userId = localStorage.getItem("user_id");
    const idParent = localStorage.getItem("b");
    const isParentAccount = userId && idParent && userId === idParent;
    const roleSettings = localStorage.getItem("roleSettings")
      ? JSON.parse(localStorage.getItem("roleSettings"))
      : null;

    let filtered = this.resolveMenuItems(items);

    if (currentUser) {
      filtered = filtered.filter(
        (x) => (x.roles && x.roles.includes(currentUser.role)) || !x.roles
      );
    } else if (roleSettings && !isAdmin && !isParentAccount) {
      filtered = filtered.filter((x) => !x.denied);
    }

    // Filter by businessType
    filtered = filtered.filter((x) => {
      if (x.businessTypes && x.businessTypes.length > 0) {
        if (!businessType) return false;
        return x.businessTypes.includes(businessType.toLowerCase());
      }
      return true;
    });

    return filtered;
  };

  resolveMenuItems = (items) => {
    const { eInvoiceEnabled } = this.state;

    return (items || [])
      .filter((item) => !item.requiresEInvoice || eInvoiceEnabled)
      .map((item) => {
        const resolvedItem = { ...item };
        delete resolvedItem.requiresEInvoice;

        if (item.conditionalEInvoiceSubmenu) {
          resolvedItem.label = eInvoiceEnabled
            ? item.label
            : item.disconnectedLabel || item.label;
          resolvedItem.subs = eInvoiceEnabled
            ? this.resolveMenuItems(item.subs || [])
            : undefined;
          delete resolvedItem.conditionalEInvoiceSubmenu;
          delete resolvedItem.disconnectedLabel;
          return resolvedItem;
        }

        if (item.subs) {
          resolvedItem.subs = this.resolveMenuItems(item.subs);
        }

        return resolvedItem;
      });
  };

  handleItemMouseEnter = (e, item) => {
    if (!this.props.menuCollapsed) return;
    const rect = e.currentTarget.getBoundingClientRect();
    this.setState({
      hoveredTooltipItem: item,
      tooltipTop: rect.top + rect.height / 2,
    });
  };

  handleItemMouseLeave = () => {
    if (this.state.hoveredTooltipItem) {
      this.setState({
        hoveredTooltipItem: null,
      });
    }
  };

  handleToggleCollapse = () => {
    const { menuCollapsed } = this.props;
    this.props.toggleMenuCollapse(!menuCollapsed);
  };

  render() {
    const { menuCollapsed, containerClassnames } = this.props;
    const { openAccordions, un_seen_mess } = this.state;
    const isMobileOpen =
      containerClassnames &&
      containerClassnames.includes("main-show-temporary");

    const visibleMenuItems = this.filteredList(menuItems);

    return (
      <aside
        className={classnames("sidebar-modern", {
          "is-expanded": !menuCollapsed,
          "is-collapsed": menuCollapsed,
          "mobile-open": isMobileOpen,
        })}
        onMouseLeave={this.handleItemMouseLeave}
      >
        {/* Brand / Logo Header at the top of Sidebar */}
        <div className="modern-sidebar-brand">
          <NavLink to="/app/pages/analytics" className="modern-brand-link">
            {menuCollapsed ? (
              <div className="brand-logo-collapsed">
                <span className="logo-mobile d-block" />
              </div>
            ) : (
              <div className="brand-logo-expanded">
                <span className="logo d-block" />
              </div>
            )}
          </NavLink>
        </div>
        <div className="modern-menu-scroll">
          <ul className="modern-nav-list">
            {visibleMenuItems.map((item) => {
              const hasSub =
                item.subs && this.filteredList(item.subs).length > 0;
              const isItemActive = this.isPathActive(item.to, item);
              const isOpen = openAccordions.includes(item.id);
              const targetId = `modern-nav-${item.id}`;

              return (
                <li
                  key={item.id}
                  className={classnames("modern-nav-item", {
                    "has-subs": hasSub,
                    "collapsed-item": menuCollapsed,
                  })}
                  onMouseEnter={(e) => this.handleItemMouseEnter(e, item)}
                  onMouseLeave={this.handleItemMouseLeave}
                >
                  {hasSub ? (
                    <div
                      id={targetId}
                      className={classnames("modern-nav-link", {
                        active: isItemActive,
                      })}
                      onClick={() => {
                        if (menuCollapsed) {
                          // If collapsed, expand menu to show sub
                          this.props.toggleMenuCollapse(false);
                          this.toggleAccordion(item.id);
                        } else {
                          this.toggleAccordion(item.id);
                        }
                      }}
                    >
                      <span className="nav-icon-box">
                        <i className={item.icon} />
                        {(item.id === "message" || item.id === "utilities") &&
                        un_seen_mess &&
                        un_seen_mess !== 0 ? (
                          <span className="modern-count-mess">
                            {un_seen_mess}
                          </span>
                        ) : null}
                      </span>

                      <span className="nav-label-box">
                        <IntlMessages id={item.label} />
                      </span>

                      <i
                        className={classnames(
                          "simple-icon-arrow-down nav-arrow-icon",
                          { "rotate-180": isOpen }
                        )}
                      />
                    </div>
                  ) : item.newWindow ? (
                    <a
                      id={targetId}
                      href={item.to}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classnames("modern-nav-link", {
                        active: isItemActive,
                      })}
                    >
                      <span className="nav-icon-box">
                        <i className={item.icon} />
                      </span>
                      <span className="nav-label-box">
                        <IntlMessages id={item.label} />
                      </span>
                    </a>
                  ) : (
                    <NavLink
                      id={targetId}
                      to={item.to}
                      className={classnames("modern-nav-link", {
                        active: isItemActive,
                      })}
                    >
                      <span className="nav-icon-box">
                        <i className={item.icon} />
                        {item.id === "message" &&
                        un_seen_mess &&
                        un_seen_mess !== 0 ? (
                          <span className="modern-count-mess">
                            {un_seen_mess}
                          </span>
                        ) : null}
                      </span>
                      <span className="nav-label-box">
                        <IntlMessages id={item.label} />
                      </span>
                    </NavLink>
                  )}



                  {/* Accordion Submenu Level 2 */}
                  {hasSub && !menuCollapsed && (
                    <Collapse isOpen={isOpen}>
                      <ul className="modern-submenu-accordion">
                        {this.filteredList(item.subs).map((sub, subIndex) => {
                          const hasThirdSub =
                            sub.subs &&
                            this.filteredList(sub.subs).length > 0;
                          const isSubActive = this.isPathActive(sub.to, sub);
                          const subKey = `${item.id}_${subIndex}`;
                          const isThirdOpen = openAccordions.includes(subKey);

                          return (
                            <li key={subKey} className="modern-sub-item">
                              {hasThirdSub ? (
                                <>
                                  <div
                                    className={classnames("modern-sub-link", {
                                      active: isSubActive,
                                    })}
                                    onClick={() => this.toggleAccordion(subKey)}
                                  >
                                    <span className="sub-icon-box">
                                      <i className={sub.icon} />
                                    </span>
                                    <span className="sub-label-box">
                                      <IntlMessages id={sub.label} />
                                    </span>
                                    <i
                                      className={classnames(
                                        "simple-icon-arrow-down sub-arrow-icon",
                                        { "rotate-180": isThirdOpen }
                                      )}
                                    />
                                  </div>
                                  <Collapse isOpen={isThirdOpen}>
                                    <ul className="modern-third-accordion">
                                      {this.filteredList(sub.subs).map(
                                        (thirdSub, thirdIndex) => {
                                          const isThirdActive =
                                            this.isPathActive(
                                              thirdSub.to,
                                              thirdSub
                                            );
                                          return (
                                            <li
                                              key={`${subKey}_${thirdIndex}`}
                                              className="modern-third-item"
                                            >
                                              <NavLink
                                                to={thirdSub.to}
                                                className={classnames(
                                                  "modern-third-link",
                                                  { active: isThirdActive }
                                                )}
                                              >
                                                <i className={thirdSub.icon} />
                                                <span>
                                                  <IntlMessages
                                                    id={thirdSub.label}
                                                  />
                                                </span>
                                              </NavLink>
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  </Collapse>
                                </>
                              ) : sub.newWindow ? (
                                <a
                                  href={sub.to}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className={classnames("modern-sub-link", {
                                    active: isSubActive,
                                  })}
                                >
                                  <span className="sub-icon-box">
                                    <i className={sub.icon} />
                                  </span>
                                  <span className="sub-label-box">
                                    <IntlMessages id={sub.label} />
                                  </span>
                                </a>
                              ) : (
                                <NavLink
                                  to={sub.to}
                                  className={classnames("modern-sub-link", {
                                    active: isSubActive,
                                  })}
                                >
                                  <span className="sub-icon-box">
                                    <i className={sub.icon} />
                                    {sub.to === "/app/pages/message" &&
                                    un_seen_mess &&
                                    un_seen_mess !== 0 ? (
                                      <span className="modern-count-mess">
                                        {un_seen_mess}
                                      </span>
                                    ) : null}
                                  </span>
                                  <span className="sub-label-box">
                                    <IntlMessages id={sub.label} />
                                  </span>
                                </NavLink>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </Collapse>
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        {/* Footer Collapse Toggle Button */}
        <div
          className={classnames("modern-sidebar-footer", {
            "is-collapsed": menuCollapsed,
          })}
        >
          <button
            type="button"
            className="modern-collapse-btn"
            onClick={this.handleToggleCollapse}
            title={menuCollapsed ? "Mở rộng menu" : "Thu gọn menu"}
          >
            <i
              className={
                menuCollapsed
                  ? "simple-icon-arrow-right"
                  : "simple-icon-arrow-left"
              }
            />
            {!menuCollapsed && <span>Thu gọn menu</span>}
          </button>
        </div>

        {/* Single Managed Floating Tooltip (No lag, strictly one at a time) */}
        {menuCollapsed && this.state.hoveredTooltipItem && (
          <div
            className="modern-collapsed-floating-tooltip"
            style={{
              top: `${this.state.tooltipTop}px`,
            }}
          >
            <div className="tooltip-arrow" />
            <div className="tooltip-inner">
              <IntlMessages id={this.state.hoveredTooltipItem.label} />
            </div>
          </div>
        )}
      </aside>
    );
  }
}

const mapStateToProps = ({ menu, authUser }) => {
  const { menuLayoutType, menuCollapsed, containerClassnames } = menu;
  const { user: currentUser } = authUser || {};
  return {
    menuLayoutType,
    menuCollapsed,
    containerClassnames,
    currentUser,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    toggleMenuCollapse,
    setMenuLayoutType,
  })(SidebarModern)
);
